import { useState } from 'react';
type useTokenType = {
  setToken: (token: string) => void,
  token: string
}
export default function useToken(): useTokenType{
  const getToken = () => {
    const tokenString = localStorage.getItem('token');
    let userToken = null;
    if (tokenString !== null) {
      userToken = JSON.parse(tokenString);
    }
    return userToken;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken: string) => {
    localStorage.setItem('token', JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
  };
}
